import React, { Component } from 'react'
import LoadingWindow from '../../../components/LoadingWindow';
import { BsFileArrowUpFill, BsFileArrowDownFill, BsArrowCounterclockwise } from "react-icons/bs";
import { AiOutlineReload } from "react-icons/ai";
import { Chart as ChartJS, ArcElement, Tooltip, Legend, CategoryScale, LinearScale, BarElement, Title, PointElement, LineElement, Filler } from 'chart.js';
import { Line, getElementAtEvent } from 'react-chartjs-2';
import { AgroupRoutes, GroupLineGraphData, LineGraphData, OptionsLineGraph, ProdLine, ProductLineFormat, Routes } from "./Class";
import "../../../css/inventory-style.css"
import "../../../css/general-style.css"
import '../../../css/table-responsive.css'
import { getValueCookie } from '../../../services/cookieService';
// import { getInformationWithDataGlobalSales, getInformationWithData } from '../../../services/CABE';
import { NumberFormat, OrderArrayASCDESC, material_cold_rgba } from '../../../functions/generalFunctions';
import { getIndexElement } from '../../../functions/searchInObject';
import { pricesFormat } from '../../../functions/pricesFormat';
import { DateFormatMAS90, formatDateByLine } from '../../../functions/dateFormat';

import axios from "axios";

export default class GeneralMarginPrices extends Component {
    constructor(props) {
        super(props)
        this.chartRef = React.createRef()
        this.ModalLoading = React.createRef();
        this.allRoutes = null;
        this.ByProdLines = []; // Initialize here
        this.prodLineMap = new Map(); // To store and reuse instances
        ChartJS.register(ArcElement, Tooltip, Legend, CategoryScale,
            LinearScale,
            BarElement,
            Title, CategoryScale,
            LinearScale,
            PointElement,
            LineElement,

            Filler,
        );
    }
    state = {
        Routes: [],
        Order:true,
        ProductLines: [],
        FilterProductLines: [],
        CheckRoutes: [],
        CheckProdLines: [],
        AllData: null,
        ItemPerDay: [],
        TitleItemPerDay: {
            ProductLine: '',
            Route: '',
            Date: '',
        },
        ScrollY:null,
        ActiveTab:'MarginsPerRoute',
        datasetVisibility: {},
        totalsWLabels: [],
        VisibleRoutes: [],
        // Variables to save the totals and recalculate the total
        routeTotalSales: [],
        routeTotalCosts: [],
        totalSales: [],
        totalCosts: [],
        RouteTotals: [],
        dateRange: [],
        RoutesArray: [],
    }

    checkFilterRouter(id, Route) {
        const checkbox = document.getElementById(id);

        if (Route === 'All' && checkbox.checked) {
            const checkboxList = document.getElementsByClassName('ReportGMRoutesP1')
            for (const checkbox of checkboxList) {
                checkbox.checked = true;
            }
        } else if (Route === 'All' && !checkbox.checked) {
            const checkboxList = document.getElementsByClassName('ReportGMRoutesP1')
            for (const checkbox of checkboxList) {
                checkbox.checked = false;
            }
        } else {
            let cond = true
            const checkboxList = document.getElementsByClassName('ReportGMRoutesP1')
            for (const checkbox of checkboxList) {
                if ((!checkbox.checked) && (checkbox.id !== 'CheckGMP1All')) {
                    cond = false
                    break
                }
            }
            let all = document.getElementById('CheckGMP1All')
            if (all) {
                all.checked = cond
            }


        }

    }
    checkFilterRouterP2(id, Route) {
        const checkbox = document.getElementById(id);

        if (Route === 'All' && checkbox.checked) {
            const checkboxList = document.getElementsByClassName('ReportGMRoutesP2')
            for (const checkbox of checkboxList) {
                checkbox.checked = true;
            }
        } else if (Route === 'All' && !checkbox.checked) {
            const checkboxList = document.getElementsByClassName('ReportGMRoutesP2')
            for (const checkbox of checkboxList) {
                checkbox.checked = false;
            }
        } else {
            let cond = true
            const checkboxList = document.getElementsByClassName('ReportGMRoutesP2')
            for (const checkbox of checkboxList) {
                if ((!checkbox.checked) && (checkbox.id !== 'CheckGMP2All')) {
                    cond = false
                    break
                }
            }
            let all = document.getElementById('CheckGMP2All')
            if (all) {
                all.checked = cond
            }


        }
        this.FilterBySelectedRouteAndProdLine()
    }

    onClick = (e, reference, Title) => {
        let Label = reference.current.data.datasets[0].label
        let Position = getElementAtEvent(reference.current, e)
        if (Position.length > 0) {
            let PosIndex = Position[0].index
            const index = getIndexElement(this.state.ProductLines, 'Title', Label)
            if (index !== -1) {
                const Title = this.state.TitleItemPerDay
                let temporal = formatDateByLine(this.state.ProductLines[index].DataLine.labels[PosIndex])
                let info = this.state.AllData[this.state.ProductLines[index].Route]["detail"][temporal]["detail"][this.state.ProductLines[index].ProdLine].detail
                for (const Line of info) {
                    Line.Margin=pricesFormat((Line.ExtensionAmt - Line.TotalCost) / (Line.ExtensionAmt) * 100)
                }
                Title.Route = this.state.ProductLines[index].Route
                Title.ProductLine = this.state.ProductLines[index].ProdLine
                Title.Date = DateFormatMAS90(temporal)
                this.setState({ ItemPerDay: info, TitleItemPerDay: Title })
                let button = document.getElementById('GMPerItem')
                if (button) {
                    button.click()
                }
            }
        }

    }

    specificDetailByRoute = (e, reference, Title) => {
        if (Title !== "Total") {
            let Position = getElementAtEvent(reference.current, e)
            if (Position.length > 0) {
                let indexDataSet = Position[0].datasetIndex
                let PosIndex = Position[0].index
                let Label = reference.current.data.datasets[indexDataSet].label
                const index = getIndexElement(this.state.Routes, 'Route', Title)
                if (index !== -1) {
                    const Title = this.state.TitleItemPerDay
                    let temporal = formatDateByLine(this.state.Routes[index].DataLine.labels[PosIndex])
                    let specificDate = this.state.AllData[Label]["detail"][temporal]["detail"]
                    let info = []
                    for (const ProductLine of Object.keys(specificDate)) {
                        info = info.concat(specificDate[ProductLine].detail)
                    }
                    for (const Line of info) {
                        Line.Margin=pricesFormat(((Line.ExtensionAmt - Line.TotalCost) / (Line.ExtensionAmt)) * 100)
                    }
                    Title.Route = Label
                    Title.ProductLine = ''
                    Title.Date = DateFormatMAS90(temporal)
                    this.setState({ ItemPerDay: info, TitleItemPerDay: Title })
                    let button = document.getElementById('GMPerItem')
                    if (button) {
                        this.ActiveTab("MarginsPerItem")
                        button.click()
                    }
                }
            }
        }


    }


    checkFilterProdLineP2(id, Route) {
        const checkbox = document.getElementById(id);

        if (Route === 'All' && checkbox.checked) {
            const checkboxList = document.getElementsByClassName('ReportGMProdLineP2')
            for (const checkbox of checkboxList) {
                checkbox.checked = true;
            }
        } else if (Route === 'All' && !checkbox.checked) {
            const checkboxList = document.getElementsByClassName('ReportGMProdLineP2')
            for (const checkbox of checkboxList) {
                checkbox.checked = false;
            }
        } else {
            let cond = true
            const checkboxList = document.getElementsByClassName('ReportGMProdLineP2')
            for (const checkbox of checkboxList) {
                if ((!checkbox.checked) && (checkbox.id !== 'CheckGMProdLineP2')) {
                    cond = false
                    break
                }
            }
            let all = document.getElementById('CheckGMProdLineP2')
            if (all) {
                all.checked = cond
            }


        }
        this.FilterBySelectedRouteAndProdLine()
    }

    OrderInformation(key){
        let order=this.state.Order?'asc':'desc'
        let temporal=OrderArrayASCDESC(this.state.ItemPerDay,key,order)
        this.setState({ItemPerDay:temporal,Order:!this.state.Order})
    }

    async getMargins(start,end, companyId) {
        const url = 'https://backv2.portalmanager.pro';
        let responseBack
        const payload = {
            data: {
                start,
                end,
                companyId
            }
        };
        let query = "/Invoices/margin-report";

        await axios.post(`${url}${query}`, payload).then(
            response => {
                responseBack = response.data
            }
        ).catch(error => {
            console.log(error)
        })
        return responseBack
    }

    async getInformation() {

        // Clean Route totals
        this.setState({RouteTotals: []})
        let Start = document.getElementById('ReportGMStartDate').value
        let End = document.getElementById('ReportGMEndDate').value
        
        this.ModalLoading.current.showState(true);
        // const result = await getInformationWithDataGlobalSales('/Invoice/report/InvoiceMarginByRoute', data)
        const result = await this.getMargins(Start,End,Number(getValueCookie('CompanyId')))
        let CheckData = []
        let CheckRoutes = [{ name: 'All' }]
        let CheckProdLines = [{ name: 'All' }]
        let routeTotalSales = []
        let routeTotalCosts = []
        let totalSales = []
        let totalCosts = []

        this.getDateRange(Start, End)
        
        if (result) {
            let RoutesArray = Object.keys(result)
            this.setState({RoutesArray})
            // let allRoutes = new Routes("All Margins", new OptionsLineGraph("All Margins"), new GroupLineGraphData())
            if (!this.allRoutes) {
                this.allRoutes = new Routes("All Margins", new OptionsLineGraph("All Margins"), new GroupLineGraphData());
            }
            let AgroupData=[]
            RoutesArray.forEach((Route, index) => {
                if (Route !== "Total") {
                    // Save the Routes (Pallet, Warehouse, etc.)
                    CheckRoutes.push({ name: Route })
                    // initialize array of showing Routes
                    this.setState(prevState => ({
                        VisibleRoutes: [...prevState.VisibleRoutes, 1]
                    }))

                    let labels = Object.keys(result[Route]["detail"])

                    let data = []
                    let ProdLines = []

                    for (const Label of labels) {
                        // // Get the total of each Route
                        const routeData = result[Route]["detail"][Label]
                        data.push(Number(routeData["PromMarkup"]).toFixed(2))
                        // // Get total Sales and cost of each Route
                        // routeTotalSales.push(routeData["ExtensionAmt"]["total"].toFixed(2))
                        // routeTotalCosts.push(routeData["TotalCost"]["total"].toFixed(2))
                        
                        // Set the totals to a state variable
                        this.generateTotalsState(routeData, Label, Route)

                        let productLines = Object.keys(result[Route]["detail"][Label]["detail"])
                        for (const ProductLine of productLines) {
                            // Get the Product line per Date per Route
                            const index = getIndexElement(ProdLines, 'ProdLine', ProductLine)
                            const index2 = getIndexElement(CheckProdLines, 'name', ProductLine)

                            if (index2 === -1) {
                                CheckProdLines.push({ name: ProductLine })
                            }

                            if (index === -1) {
                                let newP = new ProductLineFormat(ProductLine, Route)
                                newP.Dates.push(DateFormatMAS90(Label))
                                newP.Values.push(Number(result[Route]["detail"][Label]["detail"][ProductLine]["PromMarkup"]).toFixed(2))
                                ProdLines.push(newP)
                            } else {
                                ProdLines[index].Dates.push(DateFormatMAS90(Label))
                                ProdLines[index].Values.push(Number(result[Route]["detail"][Label]["detail"][ProductLine]["PromMarkup"]).toFixed(2))
                            }
                        }
                    }
                    let currentByProdLines = []; // Temporary array for this iteration

                    ProdLines.forEach((Prod, index) => {
                        const key = `${Route}-${Prod.ProdLine}`; // Unique key
                        
                        // Check if we already have this ProdLine instance
                        if (!this.prodLineMap.has(key)) {
                            // Create new instance only if it doesn't exist
                            const newProdLine = new ProdLine(
                                Route, 
                                Prod.ProdLine, 
                                new OptionsLineGraph(Route + '-' + Prod.ProdLine), 
                                new LineGraphData(Prod.Dates, Route + '-' + Prod.ProdLine, Prod.Values, material_cold_rgba(index))
                            );
                            this.prodLineMap.set(key, newProdLine);
                        } else {
                            // Update existing instance with new data
                            const existingProdLine = this.prodLineMap.get(key);
                            // Update the data (you might need to add an update method to ProdLine)
                            existingProdLine.DataLine = new LineGraphData(Prod.Dates, Route + '-' + Prod.ProdLine, Prod.Values, material_cold_rgba(index));
                        }
                        
                        currentByProdLines.push(this.prodLineMap.get(key));
                    });

                    // Update the class property
                    this.ByProdLines.push(...currentByProdLines);

                    let colorRoute = material_cold_rgba(index)

                    let newDate = []
                    for (const date of labels) {
                        newDate.push(DateFormatMAS90(date))
                    }
                    this.allRoutes.DataLine.addLabels(newDate)
                    AgroupData.push(new AgroupRoutes(Route, data, colorRoute, newDate))
           } else {
                    let labels = Object.keys(result[Route])
                    let data = []
                    for (const Label of labels) {
                        data.push(Number(result[Route][Label]["PromMarkup"]).toFixed(2))
                        totalSales.push(result[Route][Label]["ExtensionAmt"]["total"].toFixed(2))
                        totalCosts.push(result[Route][Label]["TotalCost"]["total"].toFixed(2))
                    }
                    let newDate = []
                    for (const date of labels) {
                        newDate.push(DateFormatMAS90(date))
                    }
                    CheckData.unshift(new Routes(Route, new OptionsLineGraph(Route), new LineGraphData(newDate, Route, data, material_cold_rgba(index))))
                }
                
            })
            for (const Data of AgroupData) {
                this.allRoutes.DataLine.addNewDataSet(Data.Route,Data.Data,Data.Color,Data.Dates)
            }
            CheckData.push(this.allRoutes)
        }
        const dates = CheckData[0].DataLine.labels.length
        routeTotalSales = this.chunkArray(routeTotalSales,dates)
        routeTotalCosts = this.chunkArray(routeTotalCosts,dates)
        this.setState({ Routes: CheckData, ProductLines: this.ByProdLines, FilterProductLines: this.ByProdLines, CheckRoutes: CheckRoutes, CheckProdLines: CheckProdLines, AllData: result, routeTotalSales, routeTotalCosts, totalSales, totalCosts})
        this.ModalLoading.current.showState(false);

        console.log("totalSales", this.state.totalSales)
        console.log("totalCost", this.state.totalCosts)
        console.log("RouteTotals", this.state.RouteTotals)

        // Operation for update totals
        
        // const updateTotals = routeTotalSales
    }

    // Generate array of days
    getDateRange(start, end) {
    const dateArray = [];
    let current = new Date(start + "T00:00:00"); // force set hour
    const endDt = new Date(end + "T00:00:00");

    while (current <= endDt) {
        const year = current.getFullYear();
        const month = String(current.getMonth() + 1).padStart(2, '0');
        const day = String(current.getDate()).padStart(2, '0');
        dateArray.push(`${year}-${month}-${day}`);

        // go on to the next date without exclude the end date
        current.setUTCDate(current.getUTCDate() + 1);
    }

    this.setState({dateRange: dateArray})
    }

    // Store the totals by date
    generateTotalsState(data, date, name) {
        const totalRoute = Number(data["PromMarkup"]).toFixed(2)
        const salesTotal = Number(data["ExtensionAmt"]["total"]).toFixed(2)
        const costTotal = Number(data["TotalCost"]["total"]).toFixed(2)
        let routeData = {
            name,
            totalRoute,
            salesTotal,
            costTotal,
            date
        }

        this.setState((prevState) => ({
            RouteTotals: [
                ...prevState.RouteTotals,
                routeData
            ]
        }))
    }

    // Remove route from the total
    removeRoute(routeIndex, prevTotals){
        let {dateRange, RouteTotals, totalCosts, totalSales, RoutesArray} = this.state
        let newTotalSales = []
        let newTotalCosts = []

        let routeFiltered = RouteTotals.filter(item => item.name === RoutesArray[routeIndex])

        const newTotals = dateRange.map((date, i) => {
            // Find if this date exists in routeFiltered
            const route = routeFiltered.find(r => r.date === date);
            
            if (route) {
                // Date found - calculate new total
                const calculateNewTotal = 
                    ((totalSales[i] - route.salesTotal) - (totalCosts[i] - route.costTotal)) / 
                    (totalSales[i] - route.salesTotal) * 100;
                newTotalSales.push(totalSales[i] - route.salesTotal)
                newTotalCosts.push(totalCosts[i] - route.costTotal)
                return calculateNewTotal;
            } else {
                newTotalSales.push(totalSales[i])
                newTotalCosts.push(totalCosts[i])
                // Date not found - use previous total
                return prevTotals[i];
            }
        });
        console.log("remove - newTotalSales", newTotalSales)
        console.log("remove - newTotalCosts", newTotalCosts)
        this.setState({totalSales: newTotalSales, totalCosts: newTotalCosts})
        return newTotals
        // const newTotal = ((totalSales - routeTotalSales) - (totalCost - routeTotalCost)) / (totalSales - routeTotalSales) * 100;
    }


     BackToP(id) {
        let button = document.getElementById(id)
        this.setState({ActiveTab:"MarginsPerProductLine"})
        if (button) {
             button.click()
            setTimeout(() => {  
                this.Scroll()
              }, 1000);
        }
        
       
    }

    FilterBySelectedRouteAndProdLine(){
        const checkRoute = document.getElementsByClassName('ReportGMRoutesP2')
        const checkLines = document.getElementsByClassName('ReportGMProdLineP2')
        let Items=[]
        for (const Route of checkRoute) {
            for (const ProdLine of checkLines) {
                if(Route.checked&&ProdLine.checked)
                    Items.push(Route.name+'-'+ProdLine.name)
            }
        }
        let SelectGraphs=[]
        for (const Graph of Items) {
            const index=getIndexElement(this.state.ProductLines,'Title',Graph)
            if(index!==-1){
                SelectGraphs.push(this.state.ProductLines[index])
            }
            
        }

        this.setState({FilterProductLines:SelectGraphs})

    }

    componentDidMount() {
        window.addEventListener('scroll', this.setScrollPosition);
    }

    componentWillUnmount() {
        window.removeEventListener('scroll', this.setScrollPosition);
    }

    setScrollPosition=()=>{
        if(this.state.ActiveTab==="MarginsPerProductLine"){
        let posY=window.scrollY
        this.setState({ScrollY:posY})
        }
    }
    ActiveTab(name){
        this.setState({ActiveTab:name})
        if(name==="MarginsPerProductLine"){
            setTimeout(() => {  
                this.Scroll()
              }, 1000);
        }
    }
    Scroll(){
        window.focus()
        window.scrollTo(0, this.state.ScrollY);
    }

    handleLegendClick = (datasetIndex, currentChart) => {
        // DON'T toggle currentChart here - it's already been toggled in onClick!
        // Just check its current state and sync to other charts
        
        const isNowVisible = currentChart.isDatasetVisible(datasetIndex);
        
        // 0. Update the data in state
        this.updateTotalsGraph(datasetIndex, isNowVisible);

        // 1. Get the route and visible status
        this.setState(prevState => ({
            VisibleRoutes: prevState.VisibleRoutes.map((value, index) => {
                if(index === datasetIndex){
                    return isNowVisible ? 1 : 0
                }
                return value
            })
        }))
        
        // 2. Tell Chart.js to refresh and read the new data
        setTimeout(() => {
            this.state.Routes.forEach(route => {
                const chart = route.Reference.current;
                if (chart && chart !== currentChart) {
                    // Match the visibility
                    // if (isNowVisible) {
                    //     chart.show(datasetIndex);
                    // } else {
                    //     chart.hide(datasetIndex);
                    // }
                    // Force chart to re-render with new data
                    chart.update();
                }
            });
        }, 0);

        // Update state for tracking
        this.setState(prevState => ({
            datasetVisibility: {
                ...prevState.datasetVisibility,
                [datasetIndex]: isNowVisible
            }
        }));
    }

    updateTotalsGraph = (routeIndex,isVisible) => {
        // Get the routes
        const routes = this.state.Routes[1].DataLine
        const total = this.state.Routes[0].DataLine
        // const routeNames = routes.datasets
        const dates = total.labels.length
        let newTotals = []

        // Calculate the new total without the route
        
        let routeAverages = routes.datasets[routeIndex].data
        let totalAverages = total.datasets[0].data
        // const totalRoutes = routeNames.length
        
        
        if(isVisible){
            // Convert from String to Int
            routeAverages = routeAverages.map(Number)
            totalAverages = totalAverages.map(Number)
            // Get only the active routes
            const visibleRoutes = this.countOccurrences(this.state.VisibleRoutes, 1)
            
            
            
            // Remove route from the total
            for (let i = 0; i < dates; i++){
                const newTotal  = ((totalAverages[i] * visibleRoutes + routeAverages[i]) / (visibleRoutes + 1)).toFixed(2)
                newTotals[i] = newTotal
            }
            
        } else {
            // const visibleRoutes = this.countOccurrences(this.state.VisibleRoutes, 1)
            
            // Convert from String to Int
            routeAverages = routeAverages.map(Number)
            totalAverages = totalAverages.map(Number)
            // console.log("isVisible routeAverages:", routeAverages)
            // console.log("route data", routes.datasets[routeIndex].data)
            console.log("totals data", total)
            // Remove route from the total

            newTotals = this.removeRoute(routeIndex,totalAverages)

            // for (let i = 0; i < dates; i++){
            //     console.log("totalAverages[i]",totalAverages[i])
            //     console.log("visibleRoutes",visibleRoutes)
            //     console.log("routeAverages[i]",routeAverages[i])
            //     let newTotal = 0
            //     if(visibleRoutes > 1){
            //         newTotal  = ((totalAverages[i] * visibleRoutes - routeAverages[i]) / (visibleRoutes -1)).toFixed(2)
            //         console.log("newTotal", newTotal)
            //         }
            //         newTotals[i] = newTotal
            //     }
        }

        const updatedRoutes = this.state.Routes.map((route, index) => {
            if (index === 0) {
                // Update the totals route
                return {
                    ...route,
                    DataLine: {
                        ...route.DataLine,
                        datasets: route.DataLine.datasets.map((dataset, dsIndex) => {
                            if (dsIndex === 0) {
                                return {
                                    ...dataset,
                                    data: newTotals.map(String)
                                };
                            }
                            return dataset;
                        })
                    }
                };
            }
            return route;
        });
        console.log("updatedRoutes", updatedRoutes)
        this.setState({ Routes: updatedRoutes });

    }

    countOccurrences = (arr, val) => {
        return arr.reduce((a, v) => (v === val ? a + 1 : a), 0);
    }

    // Divide in groups of the date range
    chunkArray(arr, chunkSize = 4) {
        const result = []
        for(let i = 0; i < arr.length; i+= chunkSize){
            result.push(arr.slice(i,i + chunkSize));
        }
        return result
    }

    // Simple function to reasign null or undefined values
    // checkTotalValue(labels, dates) {
    //     let datesData = []
    //     for (const Date of dates) {

    //     }
    // }

    render() {
        return (
            <div>
                <LoadingWindow ref={this.ModalLoading} />
                <div className='text-center my-4'>
                    <h2 className='display-4 fw-bold inventory-title'>General Margin Prices</h2>
                    <p className='lead text-muted inventory-subtitle'>To start please select a start and end date.</p>
                </div>
                <div className='row'>
                    <div className='col-12'>
                        <div className='row d-flex justify-content-center'>
                            <div className='col-sm-10'>
                                <div className='row'>
                                    <div className='col-sm-12 col-md-4'>
                                        <div className='row TitleText'>
                                            <div className='col-12'>
                                                <label className='form-label' htmlFor="ReportGMStartDate">Start</label>
                                                <div className="input-group input-group-lg pb-4" >
                                                    <input className="form-control form-control-lg" id='ReportGMStartDate' type="date" />
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                    <div className='col-sm-12 col-md-4'>
                                        <div className='row TitleText'>
                                            <div className='col-12'>
                                                <label className='form-label' htmlFor="ReportGMEndDate">End</label>
                                                <div className="input-group input-group-lg pb-4" >
                                                    <input className="form-control form-control-lg" id='ReportGMEndDate' type="date" />
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                    <div className='col-sm-12 col-md-4 InputTextBolder text-center d-flex align-items-center'>
                                        <button onClick={() => this.getInformation()} type="button" className="btn blueButton btn-lg w-100"><AiOutlineReload /> Load Data</button>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div hidden={this.state.AllData===null} className='col-12'>
                        <ul className="nav nav-tabs" id="ScanningControls" role="tablist">
                            <li hidden={false} className="nav-item" role="presentation">
                                <button onClick={()=>this.ActiveTab("MarginsPerRoute")} id='GMPerRoute' className="nav-link active" data-bs-toggle="tab" data-bs-target="#ReportGMPerRoute" type="button" role="tab" aria-controls="ReportGMPerRoute" aria-selected="true">Margins Per Route</button>
                            </li>
                            <li hidden={false} className="nav-item" role="presentation">
                                <button onClick={()=>this.ActiveTab("MarginsPerProductLine")} id='GMPerProductLine' className="nav-link" data-bs-toggle="tab" data-bs-target="#ReportGMPerProductLine" type="button" role="tab" aria-controls="ReportGMPerProductLine" aria-selected="false">Margins Per Product Lines</button>
                            </li>
                            <li hidden={false} className="nav-item" role="presentation">
                                <button onClick={()=>this.ActiveTab("MarginsPerItem")} hidden id='GMPerItem' className="nav-link" data-bs-toggle="tab" data-bs-target="#ReportGMPerItem" type="button" role="tab" aria-controls="ReportGMPerItem" aria-selected="false">Margins Per Item</button>
                            </li>
                        </ul>
                        <div className="tab-content" id="allScanningTab">
                            <div className="tab-pane fade show active" id="ReportGMPerRoute" role="tabpanel" aria-labelledby="ReportGMPerRoute">
                                <div className='row pt-4  pb-3'>
                                    <div className='col-sm-1' />
                                    {/*<div className='col-sm-2'>
                                        <div className='row'>
                                            {this.state.CheckRoutes.map((element, e) => (
                                                <div className="form-check col-12 text-start fontLarger textRadioButtonSize " key={e}>
                                                    <label className="form-check-label w-100" >
                                                        {element.name}
                                                        <input className="form-check-input ReportGMRoutesP1" type="checkbox" name={element.name} onChange={() => this.checkFilterRouter('CheckGMP1' + element.name, element.name)} defaultChecked id={'CheckGMP1' + element.name} />
                                                    </label>
                                                </div>
                                            ))}
                                        </div>
                                            </div>*/}
                                    <div className='col-sm-10'>
                                        <div className='row'>
                                            
                                            {/* WIP new version */}
                                            
                                            {this.state.Routes.map((Route, R) => {
                                                const modifiedOptions = {
                                                    ...Route.OptionsLineGraph,
                                                    plugins: {
                                                        ...Route.OptionsLineGraph.plugins,
                                                        legend: {
                                                            ...Route.OptionsLineGraph.plugins.legend,
                                                            onClick: (event, legendItem, legend) => {
                                                                // Toggle the dataset visibility (Chart.js default behavior)
                                                                const index = legendItem.datasetIndex;
                                                                const ci = legend.chart;
                                                                
                                                                ci.setDatasetVisibility(index, !ci.isDatasetVisible(index));
                                                                ci.update();
                                                                
                                                                // Sync other charts after a brief delay
                                                                this.handleLegendClick(index, ci);
                                                            }
                                                        }
                                                    }
                                                };
                                                
                                                return (
                                                    <div className='col-sm-6' key={Route.Route + '-' + Route.ProdLine}>
                                                        <Line 
                                                            onClick={(e) => this.specificDetailByRoute(e, Route.Reference, Route.Route)} 
                                                            ref={Route.Reference}
                                                            options={modifiedOptions} 
                                                            data={Route.DataLine} 
                                                        />
                                                    </div>
                                                );
                                            })}

                                            {/* Old version */}
                                            {/* {this.state.Routes.map((Route, R) => {
                                                    return (
                                                        <div className='col-sm-6' key={Route.Route + '-' + Route.ProdLine}>
                                                            <Line onClick={(e) => this.specificDetailByRoute(e, Route.Reference, Route.Route)} ref={Route.Reference} options={Route.OptionsLineGraph} data={Route.DataLine} />
                                                        </div>
                                                    )
                                                })
                                            } */}
                                        </div>
                                    </div>
                                    <div className='col-sm-1' />
                                </div>
                            </div>
                            <div className="tab-pane fade" id="ReportGMPerProductLine" role="tabpanel" aria-labelledby="ReportGMPerProductLine">
                                <div className='row pt-4 pb-3'>
                                    
                                    <div className='col-sm-2 ps-5'>
                                        <div className='row'>
                                            <div className='col-12 pb-3'>
                                                <h3>Routes:</h3>
                                            </div>
                                            {this.state.CheckRoutes.map((element, e) => (
                                                <div className="form-check col-12 text-start fontLarger textRadioButtonSize " key={"P2" + e}>
                                                    <label className="form-check-label w-100" >
                                                        {element.name}
                                                        <input className="form-check-input ReportGMRoutesP2" type="checkbox" name={element.name} onChange={() => this.checkFilterRouterP2('CheckGMP2' + element.name, element.name)} defaultChecked id={'CheckGMP2' + element.name} />
                                                    </label>
                                                </div>
                                            ))}
                                            <div className='col-12 pt-3 pb-3'>
                                                <h3>Product Lines:</h3>
                                            </div>
                                            {this.state.CheckProdLines.map((element, e) => (
                                                <div className="form-check col-12 text-start fontLarger textRadioButtonSize " key={"RoutesP2" + e}>
                                                    <label className="form-check-label w-100" >
                                                        {element.name}
                                                        <input className="form-check-input ReportGMProdLineP2" type="checkbox" name={element.name} onChange={() => this.checkFilterProdLineP2('CheckGMProdLineP2' + element.name, element.name)} defaultChecked id={'CheckGMProdLineP2' + element.name} />
                                                    </label>
                                                </div>
                                            ))}
                                        </div>

                                    </div>
                                    <div className='col-sm-10'>
                                        <div className='row'>
                                            {
                                                this.state.FilterProductLines.map((ProductLine, R) => (
                                                    <div className='card col-sm-5 mx-3'>
                                                        <div className='card-body'>
                                                            <div className='row'>
                                                                <div className='col-sm-6'>
                                                                    <h6 className='card-title-clean mb-0'>{ProductLine.ProdLine}</h6>
                                                                </div>
                                                                <div className='pb-3' />
                                                                <div className="tableFixHeadSmall ">
                                                                    <div key={ProductLine.Route + '-' + ProductLine.ProdLine} className={'col-sm-12 me-3'+ProductLine.Route + '-' + ProductLine.ProdLine}>
                                                                        <Line ref={ProductLine.Reference} onClick={(e) => this.onClick(e, ProductLine.Reference)} options={ProductLine.OptionsLineGraph} data={ProductLine.DataLine} />
                                                                    </div>
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </div>
                                                ))
                                            }
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div className="tab-pane fade" id="ReportGMPerItem" role="tabpanel" aria-labelledby="ReportGMPerItem">
                                <div className='row pt-4  pb-3'>
                                    <div className='col-sm-1' />
                                    <div className='col-sm-10 pb-3'>
                                        <div className='row'>
                                            <div className='col-sm-6'>
                                                <div className='row'>
                                                    <div className='col-12 pb-2'>
                                                        <div className="d-grid gap-2">
                                                            <button type="button" className="btn orangeButton btn-lg" onClick={() => this.BackToP(this.state.TitleItemPerDay.ProductLine===''?'GMPerRoute':'GMPerProductLine')}>Return <BsArrowCounterclockwise /></button>
                                                        </div>
                                                    </div>
                                                    <div className='col-12 titleTotal'>
                                                        <p>Route: </p>
                                                    </div>
                                                    <div className='col-12 TitleText'>
                                                        <p>{this.state.TitleItemPerDay.Route}</p>
                                                    </div>
                                                    <div className='col-12 titleTotal'>
                                                        <p>Date: </p>
                                                    </div>
                                                    <div className='col-12 TitleText'>
                                                        <p>{this.state.TitleItemPerDay.Date}</p>
                                                    </div>
                                                </div>
                                            </div>
                                            <div hidden={this.state.TitleItemPerDay.ProductLine===''} className='col-sm-6'>
                                                <div className='col-12 titleTotal'>
                                                    <p>Product Line: </p>
                                                </div>
                                                <div className='col-12 TitleText'>
                                                    <p>{this.state.TitleItemPerDay.ProductLine}</p>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                    <div className='col-sm-1' />
                                    <div className='col-sm-1' />
                                    <div className='col-sm-10 tableFixHead'>
                                        <table className='table align-middle'>
                                            <thead className='thead'>
                                                <tr className='table-black-header text-center'>
                                                    <th onClick={()=>this.OrderInformation('InvoiceNo')} className='bg-dark'>
                                                        <div className='row'>
                                                            <div className='col-12'>Invoice No</div>
                                                        </div>
                                                        <div className='col-12'><BsFileArrowUpFill /><BsFileArrowDownFill /></div>
                                                    </th>

                                                    <th onClick={()=>this.OrderInformation('CustomerNo')} className='bg-dark'>
                                                        <div className='row'>
                                                            <div className='col-12'>Customer No</div>
                                                        </div>
                                                        <div className='col-12'><BsFileArrowUpFill /><BsFileArrowDownFill /></div>
                                                    </th>
                                                    <th onClick={()=>this.OrderInformation('SalespersonNo')} className='bg-dark'>
                                                        <div className='row'>
                                                            <div className='col-12'>Sales Person</div>
                                                        </div>
                                                        <div className='col-12'><BsFileArrowUpFill /><BsFileArrowDownFill /></div>
                                                    </th>

                                                    <th onClick={()=>this.OrderInformation('BillToName')} className='bg-dark'>
                                                        <div className='row'>
                                                            <div className='col-12'>Customer Name</div>
                                                        </div>
                                                        <div className='col-12'><BsFileArrowUpFill /><BsFileArrowDownFill /></div>
                                                    </th>
                                                    <th onClick={()=>this.OrderInformation('ProductLineDesc')} hidden={this.state.TitleItemPerDay.ProductLine!==''} className='bg-dark'>
                                                        <div className='row'>
                                                            <div className='col-12'>Product Line</div>
                                                        </div>
                                                        <div className='col-12'><BsFileArrowUpFill /><BsFileArrowDownFill /></div>
                                                    </th>

                                                    <th onClick={()=>this.OrderInformation('ItemCode')} className='bg-dark'>
                                                        <div className='row'>
                                                            <div className='col-12'>ItemCode</div>
                                                        </div>
                                                        <div className='col-12'><BsFileArrowUpFill /><BsFileArrowDownFill /></div>
                                                    </th>

                                                    <th onClick={()=>this.OrderInformation('ItemCodeDesc')} className='bg-dark'>
                                                        <div className='row'>
                                                            <div className='col-12'>Description</div>
                                                        </div>
                                                        <div className='col-12'><BsFileArrowUpFill /><BsFileArrowDownFill /></div>
                                                    </th>

                                                    <th onClick={()=>this.OrderInformation('QuantityShipped')} className='bg-dark'>
                                                        <div className='row'>
                                                            <div className='col-12'>Quantity Shipped</div>
                                                        </div>
                                                        <div className='col-12'><BsFileArrowUpFill /><BsFileArrowDownFill /></div>
                                                    </th>

                                                    <th className='bg-dark'>
                                                        <div className='row'>
                                                            <div className='col-12'></div>
                                                        </div>

                                                    </th>

                                                    <th onClick={()=>this.OrderInformation('UnitPrice')} className='bg-dark'>
                                                        <div className='row'>
                                                            <div className='col-12'>Unit Price</div>
                                                        </div>
                                                        <div className='col-12'><BsFileArrowUpFill /><BsFileArrowDownFill /></div>
                                                    </th>

                                                    <th className='bg-dark'>
                                                        <div className='row'>
                                                            <div className='col-12'></div>
                                                        </div>

                                                    </th>

                                                    <th onClick={()=>this.OrderInformation('UnitCost')} className='bg-dark'>
                                                        <div className='row'>
                                                            <div className='col-12'>Unit Cost</div>
                                                        </div>
                                                        <div className='col-12'><BsFileArrowUpFill /><BsFileArrowDownFill /></div>
                                                    </th>

                                                    <th className='bg-dark'>
                                                        <div className='row'>
                                                            <div className='col-12'></div>
                                                        </div>

                                                    </th>

                                                    <th onClick={()=>this.OrderInformation('ExtensionAmt')} className='bg-dark'>
                                                        <div className='row'>
                                                            <div className='col-12'>Extension Amt</div>
                                                        </div>
                                                        <div className='col-12'><BsFileArrowUpFill /><BsFileArrowDownFill /></div>
                                                    </th>

                                                    <th className='bg-dark'>
                                                        <div className='row'>
                                                            <div className='col-12'></div>
                                                        </div>

                                                    </th>

                                                    <th onClick={()=>this.OrderInformation('TotalCost')} className='bg-dark'>
                                                        <div className='row'>
                                                            <div className='col-12'>Total Cost</div>
                                                        </div>
                                                        <div className='col-12'><BsFileArrowUpFill /><BsFileArrowDownFill /></div>
                                                    </th>
                                                    <th onClick={()=>this.OrderInformation('Margin')} className='bg-dark'>
                                                        <div className='row'>
                                                            <div className='col-12'>Margin</div>
                                                        </div>
                                                        <div className='col-12'><BsFileArrowUpFill /><BsFileArrowDownFill /></div>
                                                    </th>
                                                </tr>
                                            </thead>
                                            <tbody className='tbody'>
                                                {
                                                    this.state.ItemPerDay.map((item, i) => (
                                                        <tr key={i}>
                                                            <td className='text-start'>{item.InvoiceNo}</td>
                                                            <td className='text-center'>{item.CustomerNo}</td>
                                                            <td className='text-center'>{item.SalespersonNo}</td>
                                                            <td className='text-start'>{item.BillToName}</td>
                                                            <td hidden={this.state.TitleItemPerDay.ProductLine!==''} className='text-start'>{item.ProductLineDesc}</td>
                                                            <td className='text-start'>{item.ItemCode}</td>
                                                            <td className='text-start'>{item.ItemCodeDesc}</td>
                                                            <td className='text-center'>{pricesFormat(item.QuantityShipped)}</td>
                                                            <td className='text-end'>$</td>
                                                            <td className='text-end'>{NumberFormat(pricesFormat(item.UnitPrice))}</td>
                                                            <td className='text-end'>$</td>
                                                            <td className='text-end'>{NumberFormat(pricesFormat(item.UnitCost))}</td>
                                                            <td className='text-end'>$</td>
                                                            <td className='text-end'>{NumberFormat(pricesFormat(item.ExtensionAmt))}</td>
                                                            <td className='text-end'>$</td>
                                                            <td className='text-end'>{NumberFormat(pricesFormat(item.TotalCost))}</td>
                                                            <td className='text-center'>{item.Margin + '%'}</td>

                                                        </tr>
                                                    ))

                                                }
                                            </tbody>
                                        </table>
                                    </div>
                                    <div className='col-sm-1' />
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        )
    }
}
